import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ProtectedRoute from '../components/protectedRoute';
import {
  INFORMATION_PATH,
  TURNS_PATH,
  TURNS_DATE_PATH,
  HOURS_DATE_PATH,
  MY_TURN_PATH,
  CONFIRM_TURN_PATH,
  DETAIL_TURN,
  DOCTORS,
  HEALTH_INSURANCE,
  NOTIFICATION_PATH,
  QUESTION_PATH,
  REGISTER_PAGE_PATH,
  QUESTION_NEW_PATH,
  PROFILE_PATH,
} from './path';
import {
  LoginScreen, InformationScreen, DoctorsScreen,
  TurnsDate, HoursTurn, ConfirmTurn, MyTurns, DetailTurn,
  HealthInsuranceScreen, Notification, Question, RegisterScreen, NewQuestion, Profile
} from '../screens';
import NavigationMenu from '../components/navigation';

const RouteApp = () => (
  <BrowserRouter>
    <Routes>
      <Route
        path="*"
        element={(
          <NavigationMenu>
            <LoginScreen />
          </NavigationMenu>
          )}
      />
      <Route
        path={REGISTER_PAGE_PATH}
        element={(
          <NavigationMenu>
            <RegisterScreen />
          </NavigationMenu>
        )}
      />
      <Route
        path={INFORMATION_PATH}
        element={(
          <NavigationMenu>
            <InformationScreen />
          </NavigationMenu>
        )}
      />
      <Route
        path={`${TURNS_PATH}${DOCTORS}`}
        element={(
          <NavigationMenu>
            <DoctorsScreen />
          </NavigationMenu>
        )}
      />
      <Route
        path={`${TURNS_PATH}${HEALTH_INSURANCE}`}
        element={(
          <NavigationMenu>
            <HealthInsuranceScreen />
          </NavigationMenu>
        )}
      />
      <Route
        path={`${TURNS_PATH}${TURNS_DATE_PATH}`}
        element={(
          <NavigationMenu>
            <TurnsDate />
          </NavigationMenu>
        )}
      />
      <Route
        path={`${TURNS_PATH}${HOURS_DATE_PATH}`}
        element={(
          <NavigationMenu>
            <HoursTurn />
          </NavigationMenu>
        )}
      />
      <Route
        path={`${TURNS_PATH}${CONFIRM_TURN_PATH}`}
        element={(
          <ProtectedRoute>
            <NavigationMenu>
              <ConfirmTurn />
            </NavigationMenu>
          </ProtectedRoute>
        )}
      />
      <Route
        path={`${MY_TURN_PATH}`}
        element={(
          <ProtectedRoute>
            <NavigationMenu>
              <MyTurns />
            </NavigationMenu>
          </ProtectedRoute>
        )}
      />
      <Route
        path={`${DETAIL_TURN}`}
        element={(
          <ProtectedRoute>
            <NavigationMenu>
              <DetailTurn />
            </NavigationMenu>
          </ProtectedRoute>
        )}
      />
      <Route
        path={`${NOTIFICATION_PATH}`}
        element={(
          <NavigationMenu>
            <Notification />
          </NavigationMenu>
        )}
      />
      <Route
        path={`${QUESTION_PATH}`}
        element={(
          <ProtectedRoute>
            <NavigationMenu>
              <Question />
            </NavigationMenu>
          </ProtectedRoute>
        )}
      />
      <Route
        path={`${QUESTION_PATH}${QUESTION_NEW_PATH}`}
        element={(
          <ProtectedRoute>
            <NavigationMenu>
              <NewQuestion />
            </NavigationMenu>
          </ProtectedRoute>
        )}
      />
      <Route
        path={`${PROFILE_PATH}`}
        element={(
          <ProtectedRoute>
            <NavigationMenu>
              <Profile />
            </NavigationMenu>
          </ProtectedRoute>
        )}
      />
    </Routes>
  </BrowserRouter>
);

export default RouteApp;
